import type { CurveSettings } from './curveSettings';

interface RulerState {
    readonly interval: number;
    readonly scale: number;
    readonly isDisplayBothDepths: boolean;
}

interface RappersState {
    readonly isAllowedDrawRappers: boolean;
    readonly isRapperConnectionMode: boolean;
    readonly wellsGapWidth: number;
    readonly isNotDisplayRapperName: boolean;
    readonly isNotPrintRapperName: boolean;
    readonly isRecalculateDepths: boolean;
}

interface GeoObjectsState {
    readonly displayStrataConnection: boolean;
}

interface PerforationState {
    readonly isMultiColumns: boolean;
    readonly isVisibleDate: boolean;
}

interface FlowmetryState {
    readonly isVisiblePGIOnly: boolean;
}

export enum DepthType {
    Abs = 'abs',
    Rel = 'rel',
}

/**
 * Тип исследования глубины
 */
export enum DepthResearchType {
    Rigis = 'rigis',
    Inclinometry = 'inclinometry',
}
export interface GlobalCurvesSettings {
    [key: string]: CurveSettings;
}
export interface CurveSettingsPayload {
    key: string;
    color: string;
    lineType: number;
    lineWidth: number | string;
    lineDisplay: string;
    isDecimalLog?: boolean;
    isChangeMinMaxValues: boolean;
    minMaxValues: MinMaxValues;
}

type MinMaxValues = {
    xStart?: number | undefined;
    xStop?: number | undefined;
};

export type ColorElements = {
    border: string;
    grp: string;
    isolation: string;
    primary_perforation: string;
    perforation: string;
    pgi_zkc: string;
    pgi_nek: string;
    divider: string;
    layer_connections: string;
    title_background: string;
};

export interface DisplaySettingsState {
    readonly ruler: RulerState;
    readonly rappers: RappersState;
    readonly allGeoObjects: GeoObjectsState;
    readonly globalCurvesSettings: GlobalCurvesSettings;
    readonly geoObjects: GeoObjectsState;
    readonly geoObjectsRigis: GeoObjectsState;
    readonly geoObjectsFgi: GeoObjectsState;
    readonly depthType: DepthType;
    readonly perforation: PerforationState;
    readonly flowmetry: FlowmetryState;
    readonly isSyncScroll: boolean;
    readonly depthResearchType: DepthResearchType;
    readonly colors: Record<keyof ColorElements, string>;
    readonly emptyColumnsDataSettings: boolean;
    readonly isFirstDateCurve: boolean;
    readonly isLastDateCurve: boolean;
    readonly forceUpdateTablet: boolean;
}

export interface DisplaySettingsDispatch {
    setSyncScroll: (payload: boolean) => DisplaySettingsState;
    setDisplaySettings: (payload: Partial<DisplaySettingsState>) => DisplaySettingsState;
    setDepthType: (payload: DepthType) => DisplaySettingsState;
    setDepthResearchType: (payload: DepthResearchType) => DisplaySettingsState;
    updateDisplaySettings: (payload: Partial<DisplaySettingsState>) => void;
    setForceUpdateState: (payload: boolean) => void;
}
